import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import styles from "./devoteeManagement.module.scss";
import { useEffect, useState } from "react";
import {
  CustomCheckbox,
  CommonButton,
} from "../common/StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import apiPath from "../../config/apiPaths.json";
import ToastError from "../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import ToastSuccess from "../common/toast/toastSuccess";
import Pagination from "../common/pagination/pagination";
import LOCALE from '../../config/en-us.json';
import SuccessPopup from "../devotee/donation/successPopup";
import ErrorPopup from "../common/ErrorPopup";
import constants from "../../config/constants.json"


const RestoreConsolidatedAccounts = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedUsernames, setSelectedUsernames] = useState<any[]>([]);
  const [allData, setAllData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [restoreConsolidateAccountDetails, setRestoreConsolidateAccountDetails] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);


  console.log(selectedUsernames, "selectedUsernames");

  useEffect(() => {
    getRestoreApiCall()
  }, [pageNumber])

  const handleSelectAll = () => {
    const allSelected = restoreConsolidateAccountDetails.every((row) =>
      selectedRows.some((selectedRow) => selectedRow.username === row.username)
    );
  
    if (!allSelected) {
      // If not all rows are selected, select all
      setSelectedRows([...restoreConsolidateAccountDetails]);
      // And update selectedUsernames with all usernames
      setSelectedUsernames(restoreConsolidateAccountDetails.map((row) => ({ username: row.username })));
    } else {
      // If all rows are selected, clear selections
      setSelectedRows([]);
      // And clear selectedUsernames
      setSelectedUsernames([]);
    }
  };
  



  const handleCheckboxChange = (username: string) => {
    const selectedRow = restoreConsolidateAccountDetails.find((row) => row.username === username);
  
    if (selectedRow) {
      if (selectedRows.some((row) => row.username === username)) {
        setSelectedRows((prev) => prev.filter((row) => row.username !== username));
        setSelectedUsernames((prevUsernames) =>
          prevUsernames.filter((user) => user.username !== selectedRow.username)
        );
      } else {
        setSelectedRows((prev) => [...prev, selectedRow]);
        setSelectedUsernames((prevUsernames) => [
          ...prevUsernames,
          { username: selectedRow.username },
        ]);
      }
    }
  
    // Uncheck "Select All" when any other checkbox is clicked
    if (selectedRows.length === restoreConsolidateAccountDetails.length && !selectedRow) {
      setSelectedRows([]);
    }
  };
  

  const getRestoreApiCall = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.consolidateAccountMoveApi,
      includeToken: true,
      params: {
        sortBy: "",
        page: pageNumber - 1,
        size: 25,
        direction: "asc",
      },
    })
      .then((res) => {
        console.log(res.data, "dataaaa");
        setRestoreConsolidateAccountDetails(res.data.content)
        setTotalRecords(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }

  const restoreApiCall = () => {
    setLoading(true);
    const reqbody = {
      accountsToRestore: selectedUsernames
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.consilidateRestoreAccounts,
      includeToken: true,
      body: JSON.stringify(reqbody),
    })
      .then((res) => {
        setLoading(false);
        setSelectedUsernames([]);
        setSelectedRows([]);
        getRestoreApiCall();
        console.log(res.data, "restore");
        const successMessage = LOCALE.CONSOLIDATE_RESTORE_ACCOUNTS_SUCCESS;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //    duration: 10000,
        // });
        toast.custom(<SuccessPopup headerMessage="Restored Accounts" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
      })
      .catch((err) => {
        setLoading(false);
        setSelectedUsernames([]);
        setSelectedRows([]);
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const renderTableComponent = () => {
    return (
      <>
        <div>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <span>
                  <th className={styles.tableHorizontal}>
                    <div>
                      <CustomCheckbox
                        checked={
                          selectedRows.length === restoreConsolidateAccountDetails.length
                        }
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                  <th className={styles.tableHorizontal}>Username</th>
                </span>
                <th className={styles.tableHorizontal}>Full Name</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {restoreConsolidateAccountDetails.map((row, i) => (
                <tr key={i} className={styles.tableRow}>
                  <span>
                    <td className={styles.tableDiagonal}>
                      <CustomCheckbox
                        checked={selectedRows.some(
                          (selectedRow) => selectedRow.username === row.username
                        )}
                        onChange={() => handleCheckboxChange(row.username)}
                      />
                    </td>
                    <td className={styles.tableDiagonal}>{row.username}</td>
                  </span>
                  <td className={styles.tableDiagonal}>{row.fullname}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalRecords > 25 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={25}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  return (
    <Box className={styles.RestoreConsolidatedLayout}>
      <Toaster />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography className={styles.SubHeading}>
          Restore Consolidated Accounts
        </Typography>
        <CommonButton
          disabled={selectedUsernames.length === 0 || loading}
          onClick={restoreApiCall}
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Restoring...
              </span>
            </>
          ) : (
            "Restore"
          )}
        </CommonButton>
      </Box>
      {renderTableComponent()}
    </Box>
  );
};

export default RestoreConsolidatedAccounts;
